<div class="app">
  <inlite-header></inlite-header>
  <router-outlet></router-outlet>
</div>
